import { fieldType } from 'app/area/search-filters/constants';
import { FilterCommonTypes } from '../types-store';
import { FilterField, FilterPayloadValues } from './types';

export const getFieldId = (filterId: string, fieldTypeId: string) => `${filterId}_${fieldTypeId}`;

export const getInitialValues = (
  id: string,
  fieldTypeId: string,
  defaultFilterValues: FilterPayloadValues<FilterCommonTypes>
) => fieldTypeId === fieldType.excludeInherited
    ? defaultFilterValues[getFieldId(id, fieldType.excludeInherited)]
    : undefined;

export const countFilter = (
  fields: FilterField[] = [],
  values: FilterPayloadValues<FilterCommonTypes> = {} as any,
  id: string
) => fields.reduce(
  (total, field) => {

    if (field.includeInSummary === false) {
      return total;
    }

    const fieldId = getFieldId(id, field.fieldTypeId);
    const amount = values[fieldId] && values[fieldId].length || 0;
    return total + amount;
  }, 0);
